import React from 'react';
import { Link } from 'react-router-dom';
import ImgFlow from '../../images/top/img_flow.png';
import ImgFlow2x from '../../images/top/img_flow@2x.png';
import ImgWay from '../../images/top/img_way.png';
import ImgWay2x from '../../images/top/img_way@2x.png';
import ImgTobe from '../../images/top/img_tobe.png';
import ImgTobe2x from '../../images/top/img_tobe@2x.png';

const Usage = () => {
  return (
    <section className="about">
      <h2 className="sec_title">Ton Bébéのご利用について</h2>
      <p>Ton Bébéは妊娠を望む女性により多くの選択肢を提供するため、精子ドナーおよび精子提供ボランティアの方の登録を広く受け付けています。</p>
      <ul>
        <li>
          <Link to="flow">
             <img
               src={ ImgFlow }
               srcSet={ `${ ImgFlow } 1x, ${ ImgFlow2x } 2x` }
               alt="精子提供の流れ"
             />
            <h3>精子提供の流れ</h3>
          </Link>
        </li>
        <li>
          <Link to="method">
             <img
               src={ ImgWay }
               srcSet={ `${ ImgWay } 1x, ${ ImgWay2x } 2x` }
               alt="精子提供の方法"
             />
            <h3>精子提供の方法</h3>
          </Link>
        </li>
        <li>
          <Link to="to_be_donor">
             <img
               src={ ImgWay }
               srcSet={ `${ ImgTobe } 1x, ${ ImgTobe2x } 2x` }
               alt="ドナーになるには"
             />
            <h3>ドナーになるには</h3>
          </Link>
        </li>
      </ul>
    </section>
  );
}

export default Usage;
